import trim from 'lodash/trim';
import some from 'lodash/some';
import { decimalRounding } from './Pricing';

let skuPercentageOOS;
let numberOfSkus;

const getPricingCadence = (type, marketingLabel, promotions) => {
    let cadence = 'regular';

    if (type && type.length !== 0) {
        cadence = type;
    } else if (marketingLabel || promotions) {
        cadence = 'buy more and save';
    }

    return cadence;
};

const percentageLotItems = (filterLots) => {
    numberOfSkus = filterLots[0]?.items.length;
    const lotItemTotalCountAtpTrue = filterLots[0]?.items.filter((item) =>
        item.atp === false ? item.atp === false : item.atp === true ? 0 : 100
    );
    skuPercentageOOS = Object.keys(lotItemTotalCountAtpTrue)
        ? Math.round((lotItemTotalCountAtpTrue.length / filterLots[0]?.items.length) * 100)
        : lotItemTotalCountAtpTrue;
};

export const getLotDetail = (pricingDetailsForAllLots, lots) => {
    const lotDetail = [];
    if (pricingDetailsForAllLots.length > 0) {
        pricingDetailsForAllLots.map((lotWithPriceDetails) => {
            const {
                defaults,
                original,
                type,
                marketingLabel,
                promotions,
                fpac,
                lotId,
                mapPrice,
                isCouponAmount,
            } = lotWithPriceDetails;
            const filterLots = lots.filter((element) => element.id === lotId);
            const productInStock =
                filterLots && filterLots.length && filterLots[0]?.items
                    ? some(filterLots[0]?.items, { atp: true })
                    : false;
            const productCurrentSellingPrice = !mapPrice
                ? defaults && defaults.length
                    ? decimalRounding(
                          trim(defaults.split('- ')[defaults.split('- ').length - 1], '$')?.replace(
                              /,/g,
                              ''
                          )
                      )
                    : '0.00'
                : '';
            const productPriceWithCoupon = !mapPrice
                ? productInStock && isCouponAmount && fpac && fpac.length
                    ? decimalRounding(trim(fpac[0].amount.min, '$'))
                    : ''
                : '';
            const productListPrice = !mapPrice
                ? original && original.length
                    ? decimalRounding(
                          trim(original.split('- ')[original.split('- ').length - 1], '$')?.replace(
                              /,/g,
                              ''
                          )
                      )
                    : productCurrentSellingPrice
                : '';
            const productPricingCadence = getPricingCadence(type, marketingLabel, promotions);
            percentageLotItems(filterLots);
            lotDetail.push({
                lotNumber: lotWithPriceDetails.lotId,
                productCurrentPrice: productCurrentSellingPrice,
                productListPrice,
                productPriceWithCoupon,
                productPricingCadence,
                skuPercentageOOS,
                numberOfSkus,
            });
        });
    }
    return lotDetail;
};

export const getBundleLotDetail = (pricingDetailsForAllBundleLots, lots) => {
    const bundleLotDetail = [];
    if (pricingDetailsForAllBundleLots.length > 0) {
        pricingDetailsForAllBundleLots.map((lotPriceDetail) => {
            const defaultsMaxValue = lotPriceDetail.defaultsMax
                ? lotPriceDetail.defaultsMax
                : '0.00';
            const originalMaxValue = lotPriceDetail.originalMax ? lotPriceDetail.originalMax : null;
            const { type, marketingLabel, promotions, mapPrice } = lotPriceDetail;
            const filterLots = lots.filter((element) => element.id === lotPriceDetail.lotId);
            percentageLotItems(filterLots);
            bundleLotDetail.push({
                lotNumber: lotPriceDetail.lotId,
                productCurrentPrice: !mapPrice
                    ? defaultsMaxValue
                        ? decimalRounding(defaultsMaxValue).toString()
                        : '0.00'
                    : '',
                productListPrice: !mapPrice
                    ? originalMaxValue
                        ? decimalRounding(originalMaxValue).toString()
                        : '0'
                    : '',
                productPriceWithCoupon: !mapPrice
                    ? lotPriceDetail.couponInfo
                        ? decimalRounding(trim(lotPriceDetail.couponInfo.amount.min, '$'))
                        : ''
                    : '',
                productPricingCadence: getPricingCadence(type, marketingLabel, promotions),
                skuPercentageOOS,
                numberOfSkus,
            });
        });
    }
    return bundleLotDetail;
};
